import { DeprecatedModalSlideshow } from '@neshane/blueberry';

const brand = '#6366f1';
const brandLight = '#e0e7ff';
const brandDark = '#4f46e5';
const success = '#4caf50';

function EkycIllustration() {
    return (
        <svg viewBox="0 0 320 200" width="320" height="200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="20" y="30" width="180" height="130" rx="14" fill={brandLight} />
            <rect x="20" y="30" width="180" height="130" rx="14" stroke={brand} strokeWidth="3" />
            <rect x="36" y="48" width="60" height="44" rx="8" fill={brand} opacity="0.2" />
            <circle cx="66" cy="62" r="12" fill={brand} />
            <path d="M56 74c0-6 4.5-10 10-10s10 4 10 10" fill={brand} />
            <rect x="36" y="102" width="148" height="10" rx="5" fill={brand} opacity="0.35" />
            <rect x="36" y="120" width="120" height="10" rx="5" fill={brand} opacity="0.2" />
            <circle cx="252" cy="60" r="34" fill="none" stroke={success} strokeWidth="4" />
            <path d="M238 60l10 10 20-22" stroke={success} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="220" y="110" width="64" height="50" rx="8" fill="#fff" stroke={brand} strokeWidth="3" />
            <path d="M228 122h48M228 132h36" stroke={brand} strokeWidth="3" strokeLinecap="round" />
            <rect x="228" y="142" width="20" height="10" rx="3" fill={success} />
        </svg>
    );
}

function CertificateIllustration() {
    return (
        <svg viewBox="0 0 320 200" width="320" height="200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="30" y="20" width="160" height="160" rx="12" fill="#fff" stroke={brand} strokeWidth="3" />
            <rect x="30" y="20" width="160" height="40" rx="12" fill={brand} />
            <rect x="30" y="40" width="160" height="20" fill={brand} />
            <circle cx="110" cy="62" r="10" fill={brandLight} />
            <rect x="52" y="80" width="116" height="10" rx="5" fill={brand} opacity="0.35" />
            <rect x="52" y="98" width="100" height="10" rx="5" fill={brand} opacity="0.2" />
            <rect x="52" y="116" width="116" height="10" rx="5" fill={brand} opacity="0.35" />
            <rect x="52" y="134" width="72" height="10" rx="5" fill={brand} opacity="0.2" />
            <circle cx="252" cy="40" r="14" fill={success} />
            <path d="M246 40l5 5 9-9" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="228" y="80" width="48" height="66" rx="8" fill={brandLight} stroke={brand} strokeWidth="3" />
            <rect x="236" y="92" width="32" height="8" rx="4" fill={brand} opacity="0.4" />
            <rect x="236" y="106" width="32" height="8" rx="4" fill={brand} opacity="0.25" />
            <path d="M252 140l-8-10 8 4 8-4-8 10z" fill={brandDark} />
        </svg>
    );
}

function SignIllustration() {
    return (
        <svg viewBox="0 0 320 200" width="320" height="200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="20" y="20" width="170" height="150" rx="8" fill="#fff" stroke={brand} strokeWidth="3" />
            <rect x="36" y="36" width="138" height="10" rx="5" fill={brand} opacity="0.3" />
            <rect x="36" y="54" width="138" height="10" rx="5" fill={brand} opacity="0.2" />
            <path d="M40 84h90" stroke={brand} strokeWidth="3" strokeLinecap="round" opacity="0.35" />
            <path d="M40 104h70" stroke={brand} strokeWidth="3" strokeLinecap="round" opacity="0.2" />
            <rect x="36" y="122" width="56" height="34" rx="6" fill={brandLight} stroke={brand} strokeWidth="2" />
            <path
                d="M66 136c-14 4-12 18 2 14 9-2 12-12 8-18"
                stroke={brandDark}
                strokeWidth="3"
                strokeLinecap="round"
                fill="none"
            />
            <path d="M236 60h-4c-10 0-10 14 0 14h8" stroke={success} strokeWidth="5" strokeLinecap="round" fill="none" />
            <path d="M236 74h-4c-10 0-10 14 0 14h8" stroke={success} strokeWidth="5" strokeLinecap="round" fill="none" />
            <path d="M236 88h-4c-10 0-10 14 0 14h8" stroke={success} strokeWidth="5" strokeLinecap="round" fill="none" />
            <circle cx="244" cy="74" r="8" fill={success} />
            <rect x="214" y="120" width="60" height="40" rx="8" fill="#fff" stroke={brand} strokeWidth="3" />
            <path d="M222 132h24l6 6v14M252 138l-14 14M238 152h14" stroke={brand} strokeWidth="3" strokeLinecap="round" fill="none" />
        </svg>
    );
}

const SLIDES = [
    {
        title: 'احراز هویت را تکمیل کنید',
        content:
            'برای استفاده از سرویس‌های گواهی دیجیتال، ابتدا احراز هویت خود را انجام دهید. با سطح ۲ احراز هویت (کارت ملی و ویدیو) به تمام امکانات دسترسی خواهید داشت.',
        illustration: <EkycIllustration />,
    },
    {
        title: 'گواهی دیجیتال صادر کنید',
        content:
            'پس از تکمیل احراز هویت، از بخش گواهی‌ها نسبت به صدور گواهی دیجیتال خود اقدام کنید. گواهی شما به‌صورت امن بر روی حساب شما ذخیره و قابل استفاده در امضای اسناد خواهد بود.',
        illustration: <CertificateIllustration />,
    },
    {
        title: 'اسناد PDF را امضا کنید',
        content:
            'با گواهی دیجیتال خود، اسناد PDF را به‌صورت قانونی و امن امضا کنید. تاریخچه تمام امضاها در بخش تاریخچه امضا برای شما قابل مشاهده است.',
        illustration: <SignIllustration />,
    },
];

function SetupGuideModal({ isOpen, onCloseModal, onDone }) {
    return (
        <DeprecatedModalSlideshow
            slides={SLIDES}
            isOpen={isOpen}
            translations={{
                cancel: 'بعداً مشاهده می‌کنم',
                previous: 'قبلی',
                next: 'ادامه',
                done: 'متوجه شدم',
            }}
            onCancel={onCloseModal}
            onClose={onCloseModal}
            onDone={onDone}
        />
    );
}

export default SetupGuideModal;
